<div class="row rounded-card" id="settings-company">
  <div class="flex flex-wrap justify-between items-end mb-4" id="setting-view-header-wr">
    <div class="flex flex-col">
      <h2 data-testid="system-settings-company-title">{{ 'SYSTEM_SETTINGS.COMPANY.TITLE' | translate }}</h2>
      <span data-testid="system-settings-company-subtitle" class="text-base">{{ 'SYSTEM_SETTINGS.COMPANY.SUBTITLE' | translate }}</span>
    </div>
    <div class="flex items-center gap-2"></div>
  </div>

  <hr class="mb-1 mt-2 border-t">

  @if (companyFormReady) {
    <app-company-form
      [formGroup]="updateCompanyForm"
      [isUpdate]="true"
      [disableIsPrepaired]="true">
    </app-company-form>
  }

  <hr class="w-full mb-6 mt-6 border-t">
  <div class="col-12 mt-1 mb-3">
    <div class="flex items-center justify-end gap-3">
      <button data-testid="company-update-btn" class="btn primary-btn" (click)="updateCompanySettings()" [disabled]="updateCompanyForm.invalid">{{ 'SYSTEM_SETTINGS.COMPANY.SAVE_CHANGES' | translate }}</button>
    </div>
  </div>
</div>

<!-- Modalbox: create company -->
<p-dialog [(visible)]="showCreateCompanyModal" [header]="'SYSTEM_SETTINGS.COMPANY.MODALBOX_TITLE_CREATE' | translate" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false">
  <app-company-form [formGroup]="createCompanyForm" [disableIsPrepaired]="false"></app-company-form>
  <ng-template #footer>
    <button data-testid="new-company-cancel-btn" class="btn outline-btn" (click)="onCancelCreateCompany()">
      {{ 'SYSTEM_SETTINGS.COMPANY.BTN_CANCEL' | translate }}
    </button>
    <button data-testid="new-company-submit-btn" class="btn primary-btn" (click)="onCreateCompany()"
      [disabled]="createCompanyForm.invalid">
      {{ 'SYSTEM_SETTINGS.COMPANY.BTN_CREATE' | translate }}
    </button>
  </ng-template>
</p-dialog>
